<template>
	<main class="container-sm py-10">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">Información sobre la invitación</div>
			<InvitationCardMain :invitation="invitation" :placeholder="!invitation?.id" />
		</div>
		<div class="text-center fw-bold pb-10">
			¿Nada que hacer?
			<router-link :to="{ name: 'auth.logout' }" class="link-primary ps-2">Salir</router-link>
		</div>
	</main>
</template>

<script>
	import { ref, onBeforeMount } from 'vue';
	import router from '@/router';
	import composableForm from '@/composables/form';
	import InvitationRepository from '@/repositories/modules/Invitation';

	export default {
		props: {
			uuid: String
		},
		setup(props) {
			const { catchError } = composableForm();
			const invitation = ref({});

			onBeforeMount(() => {
				InvitationRepository.show(props.uuid).then((response) => {
					invitation.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'home' });
				});
			});

			return { invitation };
		}
	}
</script>